import { useForceUpdate } from '@fluentui/react-hooks';
import { createBrowserHistory } from 'history';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const history = createBrowserHistory({ window });

export const useQuery = (name: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [inited, setInited] = useState(false);
  const forceUpdate = useForceUpdate();
  let value = searchParams.get(name);

  const setValue = (newValue: string) => {
    searchParams.set(name, newValue);
    setSearchParams(searchParams);
    forceUpdate();
  };

  if (!inited) {
    const params = new URLSearchParams(window.location.search);
    value = params.get(name);
  }

  useEffect(() => {
    if (!inited && value) setValue(value);
  }, []);

  return [value, setValue] as const;
};
